

















import Vue from 'vue';

export default Vue.extend({
  components: {},
  model: {
    prop: 'radioModel',
    event: 'input',
  },
  props: {
    radioValue: {
      type: Object,
      required: true,
    },
    radioModel: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  computed: {
    radioButtonChecked(): boolean {
      return (
        JSON.stringify(this.radioValue) === JSON.stringify(this.radioModel)
      );
    },
  },
  methods: {
    selectRadioButton() {
      this.$emit('input', this.radioValue);
    },
  },
});
